<div *ngIf="categories?.length" class="categories-filters-list" fxLayout="column">
  <ng-container *ngIf="isMobileOrTablet">
    <ng-container *ngTemplateOutlet="filterItemTemplateForCategoryFacets"></ng-container>
  </ng-container>

  <div *ngIf="!isMobileOrTablet">
    <ng-container *ngTemplateOutlet="filterItemTemplate"></ng-container>
    <a
      class="categories-filters-list__show-more"
      *ngIf="hasTruncation"
      [mmTestTarget]="isExpanded ? 'category-show-less-button' : 'category-show-more-button'"
      (click)="toggleShowList(limitItems)"
    >
      {{
        isExpanded
          ? ('SHARED.SHOW_LESS.LABEL' | translate)
          : ('FILTERS.CATEGORIES_LIST.LINK.TEXT.SHOW_MORE' | translate)
      }}
    </a>
  </div>
</div>

<ng-template #filterItemTemplate>
  <div [formGroup]="categoriesForm">
    <app-search-filter-item
      *ngFor="let category of _categories | slice: 0:limitItems"
      class="categories-filters-list__item"
      [itemValue]="category.slug"
      [filters]="selectedCategoriesSlugs"
      [count]="category.totalCount"
      [hideCount]="true"
    >
      <mm-checkbox
        [mmTestTarget]="'category-filter'"
        [formControlName]="category?.slug"
        (change)="onCategoryChange(category)"
      >
        <div fxLayout="row">
          <div class="categories-filters-list__item__image" fxLayoutAlign="center center">
            <img
              [appDefaultImage]="defaultCategoryImage"
              [alt]="category.name"
              [appLazyLoadImage]="getSource(category.id)"
              [srcSet]="getSourceSet(category.id)"
            />
          </div>
          <div class="categories-filters-list__item__name" fxLayoutAlign="start center">
            <div class="categories-filters-list__item__text">
              {{ category.name }}
            </div>
          </div>
        </div>
      </mm-checkbox>
    </app-search-filter-item>
  </div>
</ng-template>
<ng-template #filterItemTemplateForCategoryFacets>
  <app-category-facets-carousel class="category__filter" [globalFilter]="true"></app-category-facets-carousel>
</ng-template>
